// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"3afe1722","116":"06508d63","294":"5cac2d0b","511":"01271755","810":"3f16818c","875":"84191dbc"}[chunkId] + ".chunk.js";
};